import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import TrustMarquee from "@/components/site/TrustMarquee";
import Categories from "@/components/site/Categories";
import Highlights from "@/components/site/Highlights";
import About from "@/components/site/About";
import Encomendas from "@/components/site/Encomendas";
import Newsletter from "@/components/site/Newsletter";
import Footer from "@/components/site/Footer";
import FloatingWhatsApp from "@/components/site/FloatingWhatsApp";

const Home = () => {
  return (
    <div className="bg-cream min-h-screen">
      <Header />
      <main>
        <Hero />
        <TrustMarquee />
        <Categories />
        <Highlights />
        <About />
        <Encomendas />
        <Newsletter />
      </main>
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
};

export default Home;
